// @generated by protoc-gen-es v2.10.0 with parameter "target=ts"
// @generated from file websocket_untrusted.proto (package com.gem.bff.contract, syntax proto3)

/* eslint-disable */
import type { Message } from '@bufbuild/protobuf';
import type { GenFile, GenMessage } from '@bufbuild/protobuf/codegenv2';
import { fileDesc, messageDesc } from '@bufbuild/protobuf/codegenv2';

import type { GetCurrentDeviceRequest } from './device/device_request_pb';
import { file_device_device_request } from './device/device_request_pb';
import type { GetCurrentDeviceResponse } from './device/device_response_pb';
import { file_device_device_response } from './device/device_response_pb';
import type { UploadKeyPackagesRequest } from './encryption/encryption_requests_pb';
import { file_encryption_encryption_requests } from './encryption/encryption_requests_pb';
import type { UploadKeyPackagesResponse } from './encryption/encryption_response_pb';
import { file_encryption_encryption_response } from './encryption/encryption_response_pb';
import type { CommonErrorResponse } from './error/error_responses_pb';
import { file_error_error_responses } from './error/error_responses_pb';
import type { DeviceStatusUpdateEvent } from './realtime_event/realtime_event_pb';
import { file_realtime_event_realtime_event } from './realtime_event/realtime_event_pb';
import { file_realtime_event_realtime_event_requests } from './realtime_event/realtime_event_requests_pb';
import { file_realtime_event_realtime_event_responses } from './realtime_event/realtime_event_responses_pb';

/**
 * Describes the file websocket_untrusted.proto.
 */
export const file_websocket_untrusted: GenFile =
  /*@__PURE__*/
  fileDesc(
    'Chl3ZWJzb2NrZXRfdW50cnVzdGVkLnByb3RvEhRjb20uZ2VtLmJmZi5jb250cmFjdCJXChJXc1VudHJ1c3RlZFJlcXVlc3QSOQoHcmVxdWVzdBgBIAEoCzImLmNvbS5nZW0uYmZmLmNvbnRyYWN0LlVudHJ1c3RlZFJlcXVlc3RIAEIGCgR0eXBlIpkBChNXc1VudHJ1c3RlZFJlc3BvbnNlEj0KBWV2ZW50GAEgASgLMiwuY29tLmdlbS5iZmYuY29udHJhY3QuUmVhbHRpbWVVbnRydXN0ZWRFdmVudEgAEjsKCHJlc3BvbnNlGAIgASgLMicuY29tLmdlbS5iZmYuY29udHJhY3QuVW50cnVzdGVkUmVzcG9uc2VIAEIGCgR0eXBlIsUBChBVbnRydXN0ZWRSZXF1ZXN0EhEKCXJlcXVlc3RJZBgBIAEoBBJLChF1cGxvYWRLZXlQYWNrYWdlcxgFIAEoCzIuLmNvbS5nZW0uYmZmLmNvbnRyYWN0LlVwbG9hZEtleVBhY2thZ2VzUmVxdWVzdEgAEkkKEGdldEN1cnJlbnREZXZpY2UYBiABKAsyLS5jb20uZ2VtLmJmZi5jb250cmFjdC5HZXRDdXJyZW50RGV2aWNlUmVxdWVzdEgAQgYKBHR5cGUilQIKEVVudHJ1c3RlZFJlc3BvbnNlEhEKCXJlcXVlc3RJZBgBIAEoBBIPCgd0cmFjZUlkGAIgASgJEjoKBWVycm9yGAMgASgLMikuY29tLmdlbS5iZmYuY29udHJhY3QuQ29tbW9uRXJyb3JSZXNwb25zZUgAEkwKEXVwbG9hZEtleVBhY2thZ2VzGAUgASgLMi8uY29tLmdlbS5iZmYuY29udHJhY3QuVXBsb2FkS2V5UGFja2FnZXNSZXNwb25zZUgAEkoKEGdldEN1cnJlbnREZXZpY2UYBiABKAsyLi5jb20uZ2VtLmJmZi5jb250cmFjdC5HZXRDdXJyZW50RGV2aWNlUmVzcG9uc2VIAEIGCgR0eXBlIm0KFlJlYWx0aW1lVW50cnVzdGVkRXZlbnQSSwoSZGV2aWNlU3RhdHVzVXBkYXRlGAEgASgLMi0uY29tLmdlbS5iZmYuY29udHJhY3QuRGV2aWNlU3RhdHVzVXBkYXRlRXZlbnRIAEIGCgR0eXBlQhgKFGNvbS5nZW0uYmZmLmNvbnRyYWN0UAFiBnByb3RvMw',
    [
      file_error_error_responses,
      file_realtime_event_realtime_event,
      file_realtime_event_realtime_event_requests,
      file_realtime_event_realtime_event_responses,
      file_encryption_encryption_requests,
      file_encryption_encryption_response,
      file_device_device_request,
      file_device_device_response,
    ]
  );

/**
 * @generated from message com.gem.bff.contract.WsUntrustedRequest
 */
export type WsUntrustedRequest = Message<'com.gem.bff.contract.WsUntrustedRequest'> & {
  /**
   * @generated from oneof com.gem.bff.contract.WsUntrustedRequest.type
   */
  type:
    | {
        /**
         * @generated from field: com.gem.bff.contract.UntrustedRequest request = 1;
         */
        value: UntrustedRequest;
        case: 'request';
      }
    | { case: undefined; value?: undefined };
};

/**
 * Describes the message com.gem.bff.contract.WsUntrustedRequest.
 * Use `create(WsUntrustedRequestSchema)` to create a new message.
 */
export const WsUntrustedRequestSchema: GenMessage<WsUntrustedRequest> =
  /*@__PURE__*/
  messageDesc(file_websocket_untrusted, 0);

/**
 * @generated from message com.gem.bff.contract.WsUntrustedResponse
 */
export type WsUntrustedResponse = Message<'com.gem.bff.contract.WsUntrustedResponse'> & {
  /**
   * @generated from oneof com.gem.bff.contract.WsUntrustedResponse.type
   */
  type:
    | {
        /**
         * @generated from field: com.gem.bff.contract.RealtimeUntrustedEvent event = 1;
         */
        value: RealtimeUntrustedEvent;
        case: 'event';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.UntrustedResponse response = 2;
         */
        value: UntrustedResponse;
        case: 'response';
      }
    | { case: undefined; value?: undefined };
};

/**
 * Describes the message com.gem.bff.contract.WsUntrustedResponse.
 * Use `create(WsUntrustedResponseSchema)` to create a new message.
 */
export const WsUntrustedResponseSchema: GenMessage<WsUntrustedResponse> =
  /*@__PURE__*/
  messageDesc(file_websocket_untrusted, 1);

/**
 * @generated from message com.gem.bff.contract.UntrustedRequest
 */
export type UntrustedRequest = Message<'com.gem.bff.contract.UntrustedRequest'> & {
  /**
   * @generated from field: uint64 requestId = 1;
   */
  requestId: bigint;

  /**
   * @generated from oneof com.gem.bff.contract.UntrustedRequest.type
   */
  type:
    | {
        /**
         * @generated from field: com.gem.bff.contract.UploadKeyPackagesRequest uploadKeyPackages = 5;
         */
        value: UploadKeyPackagesRequest;
        case: 'uploadKeyPackages';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.GetCurrentDeviceRequest getCurrentDevice = 6;
         */
        value: GetCurrentDeviceRequest;
        case: 'getCurrentDevice';
      }
    | { case: undefined; value?: undefined };
};

/**
 * Describes the message com.gem.bff.contract.UntrustedRequest.
 * Use `create(UntrustedRequestSchema)` to create a new message.
 */
export const UntrustedRequestSchema: GenMessage<UntrustedRequest> =
  /*@__PURE__*/
  messageDesc(file_websocket_untrusted, 2);

/**
 * @generated from message com.gem.bff.contract.UntrustedResponse
 */
export type UntrustedResponse = Message<'com.gem.bff.contract.UntrustedResponse'> & {
  /**
   * @generated from field: uint64 requestId = 1;
   */
  requestId: bigint;

  /**
   * @generated from field: string traceId = 2;
   */
  traceId: string;

  /**
   * @generated from oneof com.gem.bff.contract.UntrustedResponse.type
   */
  type:
    | {
        /**
         * @generated from field: com.gem.bff.contract.CommonErrorResponse error = 3;
         */
        value: CommonErrorResponse;
        case: 'error';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.UploadKeyPackagesResponse uploadKeyPackages = 5;
         */
        value: UploadKeyPackagesResponse;
        case: 'uploadKeyPackages';
      }
    | {
        /**
         * @generated from field: com.gem.bff.contract.GetCurrentDeviceResponse getCurrentDevice = 6;
         */
        value: GetCurrentDeviceResponse;
        case: 'getCurrentDevice';
      }
    | { case: undefined; value?: undefined };
};

/**
 * Describes the message com.gem.bff.contract.UntrustedResponse.
 * Use `create(UntrustedResponseSchema)` to create a new message.
 */
export const UntrustedResponseSchema: GenMessage<UntrustedResponse> =
  /*@__PURE__*/
  messageDesc(file_websocket_untrusted, 3);

/**
 * @generated from message com.gem.bff.contract.RealtimeUntrustedEvent
 */
export type RealtimeUntrustedEvent = Message<'com.gem.bff.contract.RealtimeUntrustedEvent'> & {
  /**
   * @generated from oneof com.gem.bff.contract.RealtimeUntrustedEvent.type
   */
  type:
    | {
        /**
         * @generated from field: com.gem.bff.contract.DeviceStatusUpdateEvent deviceStatusUpdate = 1;
         */
        value: DeviceStatusUpdateEvent;
        case: 'deviceStatusUpdate';
      }
    | { case: undefined; value?: undefined };
};

/**
 * Describes the message com.gem.bff.contract.RealtimeUntrustedEvent.
 * Use `create(RealtimeUntrustedEventSchema)` to create a new message.
 */
export const RealtimeUntrustedEventSchema: GenMessage<RealtimeUntrustedEvent> =
  /*@__PURE__*/
  messageDesc(file_websocket_untrusted, 4);
